import React from 'react';

import Link from 'common/Link';
import { cn } from 'common/style/utils';
import styles from 'css-module/components/subdomain/admin/v2/_AdminV2Nav.module.scss';

import Tooltip from 'common/uiV3/Tooltip';

import type { LucideIcon } from 'lucide-react';

type Props = {
  Icon: LucideIcon;
  label: string;
  to: string;
  active?: boolean;
};

export const iconLinkClass = cn(
  styles.iconLink,
  'border border-transparent',
  'unstyled-button hover:bg-sidebar-accent',
  'data-[active=true]:bg-sidebar-accent',
);

const AdminV2NavIconLink = ({ Icon, label, to, active = false }: Props) => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <Link
          aria-label={label}
          data-active={active ? true : undefined}
          className={iconLinkClass}
          to={to}>
          <Icon className="text-secondary-foreground" />
        </Link>
      </Tooltip.Trigger>
      <Tooltip.Content align="center" side="right">
        {label}
      </Tooltip.Content>
    </Tooltip>
  );
};

export default AdminV2NavIconLink;
